import React, { useState } from 'react';
import ClassifiedCard from './ClassifiedCard';
import SelectLocation from './SelectLocation';
import useActiveClassifiedList from '../../hooks/useActiveClassifiedList';
var userOwnsClassified = function (userId, classified) { return (userId && (parseInt(classified.userId, 10) === userId)); };
var shouldFocusOn = function (focusOn, classifiedId) { return focusOn && (classifiedId === focusOn); };
/**
 * Injects conversation slug to every classified a user
 * already has a conversation with.
 *
 * Note that it's possible that a user already has a conversation
 * */
// eslint-disable-next-line arrow-body-style
var mergeClassifiedsWithConversation = function (classifieds, contactedClassifieds) {
    return classifieds.map(function (classified) {
        var conversation = (contactedClassifieds[classified.id] || [])[0];
        return Object.assign(classified, {
            conversation: conversation ? conversation.conversation : null,
        });
    });
};
var ListClassifieds = function (props) {
    var isbn = props.isbn, location = props.location, focusOn = props.focusOn, _a = props.contactedClassifieds, contactedClassifieds = _a === void 0 ? [] : _a, currentUserId = props.currentUserId, onUserContact = props.onUserContact;
    var defaultLocation = 'All';
    var _b = useState(location || defaultLocation), selectedLocation = _b[0], setSelectedLocation = _b[1];
    var _c = useActiveClassifiedList({
        isbn: isbn,
        selectedLocation: selectedLocation,
    }), hasLoaded = _c.hasLoaded, locations = _c.locations, classifieds = _c.classifieds;
    if (!hasLoaded) {
        return React.createElement("div", { className: "feedback feedback-loading centered" }, "Laster inn annonser...");
    }
    if (hasLoaded && classifieds.length < 1) {
        return React.createElement("div", { className: "feedback centered" },
            React.createElement("img", { src: "static/img/404.svg", alt: "404 iBok-annonser", "aria-hidden": true }),
            React.createElement("p", null, "Det er dessverre ingen som selger denne boken brukt"));
    }
    // We need to connect information on who the user already has contacted
    // for each classified
    var categorizedClassifieds = mergeClassifiedsWithConversation(classifieds, contactedClassifieds);
    return React.createElement(React.Fragment, null,
        React.createElement(SelectLocation, { name: "location", onChange: setSelectedLocation, defaultLocation: defaultLocation, locations: locations, selected: selectedLocation }),
        React.createElement("div", { key: "classifieds", className: "grid" }, categorizedClassifieds
            .map(function (classified) { return React.createElement(ClassifiedCard, { key: "classified-" + classified.id, classified: classified, onUserContact: onUserContact, isEditable: false, isOwnedByUser: userOwnsClassified(currentUserId, classified), shouldFocus: shouldFocusOn(focusOn, classified.id) }); })));
};
export default ListClassifieds;
